(function() {
    var closeMenu = function() {
        $('.js-main-nav-sub').hide();
        $('.js-main-nav-link-scope').removeClass('toggled');
    };

    $(document).on('click', function(event) {
        if ($(event.target).closest('.js-main-nav-link-scope').length) {
            return;
        }
        closeMenu();
    });

    $('.open-submenu-trigger').click(function(e) {
        e.preventDefault();

        var scope = $(this).closest('.js-main-nav-link-scope');

        if (scope.hasClass('toggled')) {
            closeMenu();
        } else {
            closeMenu();
            scope.addClass('toggled');
            scope.find('.js-main-nav-sub').show();
        }
    });
})();
